import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
<div>
<div id="xwikicontent">
    <div id="contentSub"></div>
    <h2 id="HSOPForMultiTRFailure"><span>SOP For Multi TR Failure</span></h2>
    <p>Please use the tracking ids listed and follow the SOP linked below.&nbsp;</p>
</div>
<div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_LMP3_TRCreationFailure.jsx